export const blockIconsCommonactionsFingerprintNew = (
	<span className='material-symbols-outlined'>fingerprint</span>
);
